import request from '@/request/request'

const URLS = {
  reqSendCodeHandler: '/z-number-base/sendCode',
  reqVerificationCodeHandler: '/z-number-base/verificationCode/'
}

/* 发送 code */
export const reqSendCodeHandler = (data) => {
  return request.post(URLS.reqSendCodeHandler, data)
}


/* 校验code */
export const reqVerificationCodeHandler = (id, code) => {
  return request.get(URLS.reqVerificationCodeHandler +`${code}`+'/'+ `${id}`,   )
}
